import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
import DemoWidget from 'components/DemoWidget/DemoWidget.jsx';
import { Authenticator } from 'services/AuthService.jsx';
import Button from 'elements/CustomButton/CustomButton.jsx';
import { DataAPI } from 'services/DataService.jsx';
import moment from 'moment-timezone';

import { EventBus, EVENT_TYPE } from 'services/EventService.jsx'
import SweetAlert from 'react-bootstrap-sweetalert';

import Log from 'services/Log.jsx'



class Demo extends Component{

  constructor(props){
    super(props);
    this.state = {
      selected_project : {
        owner: {},
        plan: {}
      }
    };
  }
  componentDidMount(props) {
    Authenticator.getUser((user) => {
      Log.debug(user.selectedProject);
      if (!user.selectedProject.sandbox) {
        DataAPI.getPlan((response) => {
            Log.debug(JSON.stringify(response));
            if (response.success) {
              this.setState({selected_project: user.selectedProject, plans: response.data.plans[0]});
            }
        });
      } else {
        this.setState({selected_project: user.selectedProject});
      }
    });
  }
    render(){
        return (
            <div className="main-content project-settings">
                <Grid fluid>
                <Row className={'row-eq-height'}>
                    <Col md={12}>
                      <DemoWidget/>
                  </Col>
                </Row>
              </Grid>
            </div>
        );
    }
}

export default Demo;



// WEBPACK FOOTER //
// ./src/views/Demo/Demo.jsx